import React from 'react';
import { Input as AntInput } from 'antd';
import { InputProps } from 'antd/lib/input';
import type { InputRef } from 'antd/lib/input';

import cn from 'classnames';
import styles from './Input.module.scss';

export interface IInputProps extends InputProps {
  success?: boolean;
}

/**
 * Input component
 */
/* eslint-disable react/display-name */
export const InternalInput = React.forwardRef<InputRef, IInputProps>(
  (props, ref) => {
    const { className, success } = props;
    return (
      <AntInput
        ref={ref}
        className={cn({ [styles.success]: success }, className)}
        {...props}
      />
    );
  }
);
